
import SvgIcon from "@material-ui/core/SvgIcon"
import { ReactComponent as MicrosoftIcon } from "../fontello/icons/svg/ic_microsoft.svg"


const Microsoft = ({ ...props }) => (
  <SvgIcon
    component={MicrosoftIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Microsoft
